var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallCenterIcon = function SvgCallCenterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#355CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.921 14.483c-4.78.006-8.409-3.665-8.404-8.404 0-.31.251-.562.56-.562h1.48c.277 0 .513.204.554.479.098.658.29 1.3.57 1.903l.057.124a.396.396 0 0 1-.13.49c-.458.326-.633.985-.276 1.498a6.62 6.62 0 0 0 1.657 1.657c.514.357 1.172.182 1.499-.276a.396.396 0 0 1 .49-.13l.123.058c.604.28 1.245.471 1.903.569.275.04.479.277.479.554v1.48a.56.56 0 0 1-.561.56h-.001Z",
    fill: "#fff"
  })));
};
export default SvgCallCenterIcon;